module.exports = {
	hash: require('./lib/scrypt-async'),
	hashSync: require('./lib/scrypt-sync')
}


//////////////////
// WEBPACK FOOTER
// ./~/js-scrypt/index.js
// module id = 464
// module chunks = 0 1 2